import { render } from "./WochenplanungView.vue?vue&type=template&id=2465eab0&scoped=true"
import script from "./WochenplanungView.vue?vue&type=script&lang=js"
export * from "./WochenplanungView.vue?vue&type=script&lang=js"

import "./WochenplanungView.vue?vue&type=style&index=0&id=2465eab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2465eab0"]])

export default __exports__